import { useState, useEffect } from 'react';
import { ImageUploadApi } from '../../services/Apis';


const useFormvalidation = (callback, validate, formValues) => {
    const [values, setValues] = useState(formValues);
    const [errors, setErrors] = useState({});
    const [imgData, setImgData] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [fieldLoaders, setFieldLoaders] = useState(false);
    // useEffect(() => {
    //     setValues(formValues);
    // }, [formValues]);

    useEffect(() => {
        if (Object.keys(errors).length === 0 && isSubmitting) {
            callback();
        }
    }, [errors]);
    const handleSubmit = (event) => {
        if (event) event.preventDefault();
        setErrors(validate(values));

        setIsSubmitting(true);
    };

    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setValues(prev => ({
            ...prev,
            [name]: checked ? 1 : 0 // sending 1 or 0
        }));
    };

    const handleChange = (event) => {
        // console.log("event", event)
        event.persist();
        setValues(values => ({ ...values, [event.target.name]: event.target.value }));
    };

    const handleToggleChange = (event) => {
        setValues(values => ({ ...values, [event.target.name]: event.target.checked ? 1 : 0 }));
    };

const convertImageToWebp = (file) => {
    return new Promise((resolve) => {
        const img = new Image();
        img.src = URL.createObjectURL(file);

        img.onload = () => {
            // 🔻 Reduce dimensions to 60%
            const scale = 0.6;
            const canvas = document.createElement("canvas");
            canvas.width = img.width * scale;
            canvas.height = img.height * scale;

            const ctx = canvas.getContext("2d");

            // ❌ Metadata automatically removed here
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            canvas.toBlob(
                (blob) => {
                    if (blob) {
                        const webpFile = new File(
                            [blob],
                            file.name.replace(/\.[^/.]+$/, "") + ".webp",
                            { type: "image/webp" }
                        );
                        resolve(webpFile);
                    } else {
                        resolve(file); // fallback
                    }
                },
                "image/webp",
                0.50 // ✅ 50% quality
            );
        };
    });
};
const handlePictureChange = async (event) => {
    event.persist();

    const originalFiles = Array.from(event.target.files);
    const data = new FormData();

    data.append("webp_convert", 1);

    for (let file of originalFiles) {
        if (file.type.startsWith("image/")) {
            const webpFile = await convertImageToWebp(file);
            data.append("files", webpFile);
        } else {
            data.append("files", file);
        }
    }

    const response = await ImageUploadApi(data);

    if (event.target.multiple) {
        setValues((values) => ({
            ...values,
            [event.target.name]: [
                ...values[event.target.name],
                ...response.urls.map((item) => ({
                    file_url: item,
                    file_status: "temp",
                    webp_convert: 1,
                })),
            ],
        }));
    } else {
        const file_ = values[event.target.name];

        if (file_.length > 0 && file_.some(f => f.file_status === "processed")) {
            const formatted_data = file_.map((item) => ({
                ...item,
                file_status: "delete",
                webp_convert: 1,
            }));

            setValues({
                ...values,
                [event.target.name]: [
                    ...response.urls.map((item) => ({
                        file_url: item,
                        file_status: "temp",
                        webp_convert: 1,
                    })),
                    ...formatted_data,
                ],
            });
        } else {
            setValues({
                ...values,
                [event.target.name]: [
                    ...values[event.target.name].filter(
                        ({ file_status }) => file_status === "delete"
                    ),
                    ...response.urls.map((item) => ({
                        file_url: item,
                        file_status: "temp",
                        webp_convert: 1,
                    })),
                ],
            });
        }
    }
};

    const handleEditorChange = (e) => {
        const { name, value } = e.target;

        setValues((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleRemoveImage = (name, index) => {
        const file_ = values[name][index];
        if (file_.file_status == "processed") {
            const formatted_data = {
                ...file_,
                file_status: 'delete'
            }
            setValues({
                ...values,
                [name]: [...values[name].filter((_, i) => i !== index), formatted_data]
            });
        } else {
            setValues({
                ...values,
                [name]: values[name].filter((_, i) => i !== index)
            });
        }
    };

    return {
        handleChange,
        handlePictureChange,
        handleCheckboxChange,
        handleToggleChange,
        handleRemoveImage,
        handleSubmit,
        imgData,
        values,
        handleEditorChange,
        setErrors,
        setValues,
        errors,
        fieldLoaders,
    }
};
export default useFormvalidation;